import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteConfirmationComponent } from './delete-confirmation';
import { ModalService } from './modal.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ChangesConfirmationComponent } from './changes-confirmation';
import { MaterialModalService } from 'app/core/modal/material-modal.service';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [CommonModule, ModalModule, ModalModule.forRoot(), MatDialogModule],
  declarations: [DeleteConfirmationComponent, ChangesConfirmationComponent],
  exports: [DeleteConfirmationComponent, ChangesConfirmationComponent],
  providers: [ModalService, MaterialModalService]
})
export class AppModalModule {}
